export const intervalTimer = (second: number, callback: () => void): NodeJS.Timer => {
  callback();
  return setInterval(callback, second * 1000);
};
